import "./InsurancePlanLookupDialog.css";

import { ChangeEventHandler } from "react";

import { InsurancePlan } from "pwapi";

import AdvancedInsurancePlanLookup, {
  Option,
} from "shared/components/AdvancedInsurancePlanLookup";

const InsuranceLookupTextInput = ({
  label,
  onChange,
  id,
  value,
}: {
  label?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  id?: string;
  value: string;
}) => {
  return (
    <div className="Input">
      <label htmlFor={id}>{label}</label>
      <input type="text" id={id} name={id} onChange={onChange} value={value} />
    </div>
  );
};

const InsuranceLookupSelectInput = ({
  label,
  onChange,
  id,
  value,
  options,
}: {
  label?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  id?: string;
  value: string;
  options: Option[];
}) => {
  return (
    <div className="Input">
      <label htmlFor={id}>{label}</label>
      <select id={id} name={id} value={value} onChange={onChange}>
        <option value="">...</option>
        {options.map((opt) => (
          <option key={opt.label} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const InsurancePlanLookupDialog = ({
  selectedInsurance,
  apiService,
  onSelect,
  onClose,
}: {
  selectedInsurance?: InsurancePlan;
  apiService: Function;
  onSelect: Function;
  onClose: Function;
}) => {
  //TODO: Replace with normal modal if available
  return (
    <>
      <div
        className="ModalBackdrop"
        onClick={() => {
          onClose();
        }}
      >
        <div
          className="InsuranceModal"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span className="Modal__header">Look up insurance plan</span>
          <div className="Modal__container">
            <AdvancedInsurancePlanLookup
              TextInput={InsuranceLookupTextInput}
              SelectInput={InsuranceLookupSelectInput}
              selectedPlan={selectedInsurance}
              apiOperation={apiService}
              onSelectItem={onSelect}
            />
          </div>
          <div className="Modal__controls">
            <button
              className="Button"
              type="button"
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InsurancePlanLookupDialog;
